// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image{display:flex}.image .title-area{width:100%;margin:20px 15px}.image .title-area .titles{width:100%;gap:25px;display:flex;flex-direction:column}.image .title-area .titles .title .text{font-weight:bold}", ""]);
// Exports
module.exports = exports;
